import { Box, Typography } from "@mui/material"
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'

const AutoAssignedBadge = ({ autoAssigned }) => {
    if (!autoAssigned) return null

    return (
        <Box sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '3px',
            backgroundColor: '#E8F5E9',
            border: '1px solid #A5D6A7',
            borderRadius: '4px',
            padding: { xs: '1px 4px', md: '2px 6px', xl: '3px 8px' },
            flexShrink: 0
        }}>
            <AutoFixHighIcon sx={{ fontSize: { xs: '9px', md: '11px', xl: '13px' }, color: '#2E7D32' }} />
            <Typography sx={{
                fontFamily: 'Rubik',
                fontSize: { xs: '7px', md: '8px', lg: '9px', xl: '11px' },
                fontWeight: 600,
                color: '#2E7D32',
                whiteSpace: 'nowrap'
            }}>
                Auto-assigned
            </Typography>
        </Box>
    )
}

export default AutoAssignedBadge
